import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchRoles(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/roles', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchRol(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/roles/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addRol(ctx, rolData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/roles`, { rol: rolData })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteRol(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/roles/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateRol(ctx, rolData) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/roles/${rolData.id}`, { rol: rolData })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}